import { ExtractDayPipe } from '../../../../../_helpers/_pipes/extract-day.pipe';
import { ReplacePipe } from '../../../../../_helpers/_pipes/replace.pipe';
import { AutopayUnenrolledPreconfirmComponent } from '../autopay-unenrolled/autopay-unenrolled-preconfirm/autopay-unenrolled-preconfirm.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { AutopayPaymentMethodModalComponent } from './autopay-payment-method-modal/autopay-payment-method-modal.component';
import { AutopayEnrollModalComponent } from './autopay-enroll/autopay-enroll-modal/autopay-enroll-modal.component';
import { PaymentCCDCSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/payment-cc-dc/payment-cc-dc.component';
import { ImpNoticeComponent } from '../../imp-notice/imp-notice.component';
import { ManageAutopayImpNoticeComponent } from '../../imp-notice/manage-autopay-imp-notice/manage-autopay-imp-notice.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { PaperlessService } from '../../../../../_services/_iam/paperless.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { EnrollEftEpayService } from '../../../../../_services/forms/enroll-eft-epay/enroll-eft-epay.service';
import { AgentNotificationService } from '../../../../../_services/agent/agent-notification.service';
import { AutopayBillingService } from '../../../../../_services/my-insurance/autopay-billing.service';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';
import { BankAccountService } from '@services/profile-settings/bank-account.service';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';
import { DataLayerService } from '@services/data-layer/data-layer.service';
import { SortByStatusPipe } from '@helpers/_pipes/sort-by-status.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, ManageAutopayImpNoticeComponent, ImpNoticeComponent, PaymentCCDCSvgComponent, AutopayEnrollModalComponent, AutopayPaymentMethodModalComponent, MapfreButtonComponent, AutopayUnenrolledPreconfirmComponent, ReplacePipe, ExtractDayPipe, SortByStatusPipe],
  selector: 'app-autopay',
  templateUrl: './autopay.component.html',
  styleUrls: ['./autopay.component.scss'],
})
export class AutopayComponent implements OnInit, OnDestroy {
  policyInfo: any;
  hideModal: boolean;
  loading = true;
  isAcmic: boolean;
  showEnrollImpNotice: boolean;
  showTwCCDCImpNotice: boolean;
  twCCDCImpText: string;
  constructor(
    private policyDataService: PolicyDataService,
    private alertService: AlertService,
    public router: Router,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private paperlessService: PaperlessService,
    private errorRedirectionService: ErrorRedirectionService,
    private policyDetailsService: PolicyDetailsService,
    private enrollEftEpayService: EnrollEftEpayService,
    private acmicService: AcmicService,
    private agentNotificationService: AgentNotificationService,
    private autopayBillingService: AutopayBillingService,
    public navService: NavigationService,
    private bankAccountService: BankAccountService,
    private paymentService: PaymentServiceService,
    private dataLayer: DataLayerService
  ) {  }

  ngOnInit() {
    this.twCCDCImpText = 'To update your credit or debit card on file, please unenroll first, then re-enroll using your new card.';
    this.isAcmic = this.acmicService.isACMIC();
    this.autopayBillingService.setAutopayAlert(true);
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        policyResponse.map((policy) => {
          const { effDate } = policy;
          if (effDate) {
            policy.autoPay =
              this.policyDetailsService.getDayDifference(effDate);
          }
        });
        this.policyInfo = this.sortPolicies(policyResponse);
        this.checkAutopayDetails();
        this.showEnrollImpNotice = this.policyInfo.some(p => {
          return p.isAutoPayAvailable && !p.maBadCheck 
                    && (p.policyFlags?.isEft==='UNENROLLED' || p.policyFlags?.isEft==='FALSE')
        })
        this.showTwCCDCImpNotice = this.policyInfo.some(p => {
          return p.isAutoPayAvailable && !p.maBadCheck && p?.isTWRecurringCCDC
        })
        this.loading = false;
      }
    });
    this.navService.saveCurrentAction(ActionType.ManageAutopay);
  }

  private sortPolicies(policies): any[]{
    const withBadCheck = policies.map(policy => ({
      ...policy,
      isAutoPayAvailable: this.isAutoPayAvailable(policy),
      isTWRecurringCCDC: policy?.company.companyName==='TW' 
                          && policy?.billingDetails[0]?.noticeType === 'RECURRING CC/DC'
                          && policy?.policyFlags.isEft === 'ENROLLED',
      maBadCheck: !this.isAcmic 
                  && (policy?.billingDetails[0]?.badCheckCount !== 'N' || policy?.billingDetails[0]?.mortageeFlag !== 'N'),
      isPendingStatus: (policy?.policyFlags.isEft === 'ENROLLMENT-PENDING' || policy?.policyFlags.isEft === 'UNENROLLMENT-PENDING'
                    || policy?.policyFlags.isEft === 'UPDATE-PENDING'),
    }))

    return [
      ...withBadCheck.filter(p => !p.maBadCheck && (p.policyFlags?.isEft==='UNENROLLED' || p.policyFlags?.isEft==='FALSE')),
      ...withBadCheck.filter(p => !p.maBadCheck && !(p.policyFlags?.isEft==='UNENROLLED' || p.policyFlags?.isEft==='FALSE')),
      ...withBadCheck.filter(p => p.maBadCheck)
    ];
  }

  private checkAutopayDetails(){
    this.policyInfo.forEach(policy => {
      if(this.isEligibleToShowAutopayDetails(policy) && !policy?.autoPayDetails){
        this.bankAccountService
          .getBankInformation(policy.policynumber?.policyNumber)
          .subscribe((bankDetail) => {
            policy.autoPayDetails = {
              bankAccount: bankDetail['bankAccount'],
              deductionDay: bankDetail['deductionDay']
             };
          });
      }
    })
  }

  isEligibleToShowAutopayDetails(policy: any): boolean{
    return !policy?.maBadCheck && !policy?.isPendingStatus
              && (policy?.policyFlags.isEft === 'ENROLLED' || policy?.policyFlags?.isEft==='TRUE') 
              && !policy?.autoPayDetails?.cardType 
              && !(policy?.company.companyName==='TW' || policy?.company.companyName==='ACIC')
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  enrollInAutopay(policy, type, event?: string) {
    this.agentNotificationService.setAgentInfo(policy);
    this.enrollEftEpayService.setPrevEftRoute(this.router.url);
    if (
      (policy &&
        policy['days_left_to_expire'] &&
        policy['days_left_to_expire'] <= 30 &&
        policy.policynumber.policyNumber.length === 6 &&
        policy.livoPolicy) ||
      policy['isNewPolicy']
    ) {
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scroll(0, 0);
    } else {
      if (type === 'ENROLL') {
        const enrollNav = [
          '/billing',
          'paperless',
          'e-pay',
          policy.policynumber.policyNumber,
          'enroll',
        ];
        if (event?.includes('CREDIT-DEBIT-CARD')) {
          this.router.navigate(enrollNav, {
            queryParams: { method: "card" },
          });
        } else
          this.router.navigate(enrollNav);
      } else if (type === 'UPDATE') {
        if(policy?.company?.companyName === 'TW'){
          this.dataLayer.pushManagePolicyEvent('Edit autopay')
        }
        this.router.navigate([
          '/billing',
          'paperless',
          'e-pay',
          policy.policynumber.policyNumber,
          'edit-enroll',
        ]);
      }
    }
  }

  cancelAutopayCCDC(policy, action?: string){
    const email = this.storageServiceObservablesService.getUserFromStorage();
    this.paymentService
          .unenrollFromAutopayCCDC(policy.policynumber.policyNumber, email)
          .subscribe((response) => {
            console.log("UnEnrolling from Autopay response : ", response)
            if(response){
              this.reSync(email, policy.policynumber.policyNumber, true, action);
            }else{
              this.router.navigate( ['/billing/autopay'] );
            }
          },
          () => {
             this.loading = false;
              this.router.navigate( ['/billing/autopay'] );
          });    
  }

  cancelAutopay(policy, where, action?: string): void {
    this.loading = true;
    if(policy.isTWRecurringCCDC){
      this.cancelAutopayCCDC(policy, action)
      return;
    }

    this.agentNotificationService.setAgentInfo(policy);
    if (
      (policy &&
        policy['days_left_to_expire'] &&
        policy['days_left_to_expire'] <= 30 &&
        policy.policynumber.policyNumber.length === 6 &&
        policy.livoPolicy) ||
      policy['isNewPolicy']
    ) {
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scroll(0, 0);
    } else {
      const email = this.storageServiceObservablesService.getUserFromStorage();
      if (where == 'e-pay') {
        this.paperlessService
          .cancelPaperlessEPay(policy, email)
          .subscribe(
            () => {
              this.reSync(email, policy.policynumber.policyNumber);
            },
            (error) => {
              if (error.status === 500) {
                this.loading = false;
                this.alertService.error('PROBLEM_IN_REQUEST_PROCESSING');
              } else if (error && error.status === 503) {
                this.errorRedirectionService.errorRedirectHandler(
                  error,
                  policy.policynumber.policyNumber
                );
              } else {
                this.errorRedirectionService.errorHandler(
                  error,
                  'PROBLEM_IN_REQUEST_PROCESSING'
                );
              }
            }
          );
      }
    }
  }

  reSync(email, policyid, isRecurringCCDC?: boolean, action?: string): void {
    this.policyDataService.clear();
    this.policyDetailsService.getPolicyDetailsByEmail(email)
      .subscribe( () => {
        this.policyDataService.$policyDetails
            .subscribe((policyResponse) => {
              if (policyResponse && policyResponse.length > 0) {
                const policy = policyResponse.find((response) => response.policynumber.policyNumber === policyid);
                if((policy?.company?.companyName === 'TW' && !isRecurringCCDC) || policy?.company?.companyName === 'ACIC'){
                  policy.policyFlags.isEft = 'UNENROLLMENT-PENDING'
                }
              }});
        if(action && action === "unenrollToEdit")
          this.router.navigate( ['/billing/autopay'] );
        else
          this.router.navigate(['/billing', policyid, 'unenrolled']);        
      }, (error) => {
        this.errorRedirectionService.errorRedirectHandler(error);
      }
    );
    window.scroll(0, 0);
  }

  isAutoPayAvailable(policy: any){
    return (policy?.policyFlags.isEftEligible === 'Y' && policy?.isNewPolicy && policy?.autoPay <= 0 
              || policy?.policyFlags.isEftEligible === 'Y' && !policy?.isNewPolicy) 
            && !policy.hasAffinityGroup && policy?.policyStatus === 'ACTIVE' 
            && !(policy?.policyCancellationReason 
                  && (policy?.policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium' 
                        || policy?.policyCancellationReason.toLowerCase() === 'fpd - failure to pay deposit') 
                  && policy?.policyFlags.isEft === 'UNENROLLED' );
  }

  ngOnDestroy(): void {
    this.autopayBillingService.setAutopayAlert(false);
  }
}
